module.exports = __webpack_public_path__ + "img/periodic_geo_out.bba9b6f7.png";